export default __webpack_public_path__ + "static/media/36I-120629_-43877_0.696a7ead.jpg";